module.exports = __webpack_public_path__ + "media/images/placeholder-wide-c564398bef8b5aeddadfe93af900d7a8.png";